export default Object.freeze({
  START: 'start',
  PLAY: 'play',
  PAUSE: 'pause',
  STOP: 'stop'
})
